var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmcPhoneAppTheGramHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.41 11.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3c3c3b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.65,11.69h-2.26c-.59,0-1.06-.48-1.06-1.06v-2.88h-1.26v2.88c0,.59-.48,1.06-1.06,1.06H2.76c-.59,0-1.06-.48-1.06-1.06V6.62H.78c-.43,0-.78-.35-.78-.78,0-.25,.12-.48,.32-.63L5.97,.27c.34-.35,1.09-.38,1.49,.03l5.66,4.94c.17,.12,.29,.35,.29,.6,0,.43-.35,.78-.78,.78h-.91v4.01c0,.59-.48,1.06-1.06,1.06ZM5.08,6.75h3.26v3.88l2.32,.06,.06-5.08h1.33L6.7,.98s-.03,0-.04,.02L1.36,5.62h1.33v5.01l2.32,.06,.06-3.95Zm7.39-.76s.02,.02,.03,.03l-.03-.03Zm-11.52-.01h0s0,0,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmcPhoneAppTheGramHome);
export default __webpack_public_path__ + "static/media/MMC_Phone App_TheGram_Home.362f65e5ebd8ed256ef89a244c88442a.svg";
export { ForwardRef as ReactComponent };